import type { ViewportOptions } from "framer-motion";

/** Entrances use expo-out: fast start, long settle — reads as "arrives", not "slides". */
export const ease = {
  entrance: [0.16, 1, 0.3, 1] as const,
  hover: [0.33, 1, 0.68, 1] as const,
  inOut: [0.65, 0, 0.35, 1] as const,
};

export const duration = {
  press: 0.12,
  hover: 0.24,
  reduced: 0.15,
  base: 0.55,
  slow: 0.8,
} as const;

/** Travel distance in px. Above ~48 it reads as a page transition, not a reveal. */
export const travel = { sm: 12, md: 24, lg: 40 } as const;

/** Interval between staggered siblings, in seconds. */
export const interval = { tight: 0.05, base: 0.08, loose: 0.14 } as const;

/**
 * amount 0.2 (not 0.5) so tall sections still trigger.
 * The -12% bottom margin shrinks the observer root, starting the reveal just
 * before the element is comfortably on screen rather than the instant it clips in.
 * once: true also disconnects the IntersectionObserver after firing.
 */
export const viewport: ViewportOptions = {
  once: true,
  amount: 0.2,
  margin: "0px 0px -12% 0px",
};
